export default "__VITE_ASSET__c5oYfgRR__"